import axios from 'axios';
import { config } from '../config';
import securityLogger from '../utils/securityLogger';

// Create axios instance with base URL
const apiClient = axios.create({
  baseURL: config.API_BASE_URL,
  timeout: 30000, // 30 second timeout
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle common errors
    if (error.response?.status === 401) {
      // Unauthorized - clear token and redirect to login
      securityLogger.warn('Unauthorized access detected, clearing token and redirecting to login', {
        status: error.response.status,
        url: error.config?.url
      });
      sessionStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Environment-aware debug logging
securityLogger.debug('API client configured', {
  baseURL: config.API_BASE_URL,
  environment: process.env.NODE_ENV
});

export default apiClient;
